import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser } from '../../../reducers'
import cloneDeep from 'lodash.clonedeep'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import FormBidOrder from '../../containers/FormBidOrder'
import { firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import LoadingPage from '../../components/LoadingPage'
import './styles.css'
import moment from 'moment'
import { storage } from '../../../config/Fire'

const DetailsBid = props => {
    const [updatingBidOrder, setUpdatingBidOrder] = useState(false)
    const [detailsBidOrder, setDetailsBidOrder] = useState(null)

    useEffect(() => {
        if (props.bidOrderToEdit) {
            props.bidOrderToEdit.startDate = moment(props.bidOrderToEdit.startDate, 'DD/MM/YYYY')
            setDetailsBidOrder(props.bidOrderToEdit)
        }
    }, [props.bidOrderToEdit])
    
    const updateBidOrder = async bidOrder => {
        if (bidOrder && detailsBidOrder && detailsBidOrder.id) {
            const bidOrderCopy = cloneDeep(bidOrder)
            setUpdatingBidOrder(true)
            let month = bidOrder.startDate.month() + 1 < 10 ? `0${bidOrder.startDate.month() + 1}` : bidOrder.startDate.month() + 1
            let customDate = `${bidOrder.startDate.date()}/${month}/${bidOrder.startDate.year()}`
            bidOrderCopy.startDate = customDate
    
            if (bidOrder.fileItem) {
                let fileUrl = `bids/${detailsBidOrder.id}/cotizacion-${bidOrder.quotation}.pdf`;
                try {
                    await storage.ref().child(fileUrl).put(bidOrder.fileItem.file.originFileObj)
                    bidOrderCopy.fileUrl = fileUrl
                } catch (err) {
                    setUpdatingBidOrder(false)
                    console.log(err)
                    message.error('Se produjo un error al editar la cotización. Por favor, vuelva a intentarlo')
                    return
                }
            }
            delete bidOrderCopy.fileItem
            if (bidOrderCopy.newClient === undefined) bidOrderCopy.newClient = ''
            if (bidOrderCopy.new === undefined) bidOrderCopy.new = ''
            const bidOrderToUpdate = { ...bidOrderCopy }
            firestore.collection(Constants.MAIN_NODES.BID_ORDERS).doc(detailsBidOrder.id).update(bidOrderToUpdate)
                .then(() => {
                    setUpdatingBidOrder(false)
                    message.success('¡La licitacíon se editó exitósamente!')
                    props.onUpdateBidOrder(bidOrderToUpdate)
                })
                .catch(err => {
                    setUpdatingBidOrder(false)
                    console.log(err)
                })
        }
    }

    return (
        <Grid className="newWorkCont">
            {
                detailsBidOrder ?
                    <div>
                        <Row center="xs">
                            <Col xs={12}>
                                <h2>Edición - Cotización</h2>
                            </Col>
                        </Row>
                        <Divider/>
                        <Row center="xs">
                            <Col xs={12}>
                                <FormBidOrder
                                            clients={props.clients} 
                                            isEditing={true}
                                            bidOrderToEdit={detailsBidOrder}
                                            onSubmitBidOrder={updateBidOrder}
                                            loading={updatingBidOrder}
                                            outsourcing={props.outsourcing}/>
                            </Col>
                        </Row>
                        <Row center="xs">
                            <Col xs={6}>
                                <Button onClick={() => props.onBack(false, null)} loading={updatingBidOrder}>
                                    Salir
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    :
                    <LoadingPage/>
            }
        </Grid>
    )
}

DetailsBid.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(DetailsBid))
